<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :show-close="true"
    :subject="subject"
    :subtitle="subtitle"
    :theme="currentTheme"
    width="20%"
    showCancelBtn
    @on-confirm="confirmHandler"
    @close="handleClose"
  >
    <el-row>
      <template v-if="!isAll && !isBulk">
        <div>
          <span>{{ $t("component.dialog.publisher") }}：</span>
          <span>{{ username }} ({{ usernickname }})</span>
        </div>
        <div>
          <span>{{$t('column.social_account')}}：</span>
          <span>{{ social_account }}</span>
        </div>
      </template>
      <template v-if="!isAccept">
        <el-container v-if="!isDoubleReject" direction="vertical">
          <span class="text-primary mp-2 mm">{{
            $t("message.error.reject")
          }}</span>
          <el-input
            v-model="rejectMessage"
            type="textarea"
            maxlength="60"
            show-word-limit
          ></el-input>
        </el-container>
        <div v-else>
          <span class="text-primary">{{ $t("component.dialog.reject_reason") }}：</span>
          <span class="text-warning">{{ rejectMessage }}</span>
        </div>
      </template>
    </el-row>

    <template slot="footer">
      <el-row type="flex" justify="space-around">
        <button type="button" @click="$refs.dialog.close()">
          {{ $t("component.btn.cancel") }}
        </button>
        <button type="button" class="confirm" @click="confirmHandler">
          {{ confirmLabel }}
        </button>
      </el-row>
    </template>
  </tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";
import apis from "@/apis";

const api = apis.tg_business.member.review;

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      isDoubleReject: false,
      rejectMessage: "",
      targetUserIds:[],
    };
  },
  computed: {
    action() {
      return (this.isAll || this.isBulk) ? this.item.action.substr(0, 6) : this.item.action;
    },
    isAccept() {
      return this.action == "accept";
    },
    currentTheme() {
      return this.isAccept ? "info" : "warning";
    },
    isAll() {
      return this.item && this.item.action && this.item.action.endsWith("-all");
    },
    isBulk() {
      return this.item && this.item.action && this.item.action.endsWith("-bulk");
    },
    subject() {
      if (this.isAll) {
        return this.$t("component.dialog.subject.member-review-all");
      } else if (this.isBulk) {
        return this.$t("component.dialog.subject.member-review-bulk");
      } else {
        return this.$t("component.dialog.subject.member-review");
      }
    },
    subtitle() {
      // let title = this.isAll ? "全部会员申请" : "会员申请";
      let key = "";

      if (this.isAll) {
        key = this.$t("component.dialog.subtitle.member-review-all");
      } else if (this.isBulk) {
        key = this.$t("component.dialog.subtitle.member-review-bulk");
      } else {
        key = this.$t("component.dialog.subtitle.member-review");
      }
      
      return "(" + this.actionLabel + ")" + this.$t(key);
    },
    actionLabel() {
      let status = this.isAccept ? 1 : 0;
      let langKey = "component.dialog.status.member-review[" + status + "]";
      return this.$t(langKey);
    },
    username() {
      return this.item.username;
    },
    usernickname() {
      return this.item.usernickname;
    },
    social_account() {
      return this.item.social_account;
    },
    confirmLabel() {
      if (this.isDoubleReject) {
        return this.$t("component.btn.reconfirm");
      }

      return this.$t("component.btn.confirm");
    },
  },
  methods: {
    confirmHandler() {
      if (!this.isAccept) {
        if (!this.rejectMessage) {
          this.$message.error(this.$t("message.error.reject"));
          return;
        }

        if (!this.isDoubleReject) {
          this.isDoubleReject = true;
          return;
        }
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      api.action[this.item.action]({
        targetName: this.username,
        reason: this.rejectMessage,
        targetUserIds: this.item.targetUserIds,
      })
        .then((response) => {
          this.$store.dispatch("app/fetch");
          this.$emit("on-success", { response, isAccept: this.isAccept });          
          this.$refs.dialog.close();
          loading.close();
        })
        .catch(() => {
          this.$refs.dialog.close();
          loading.close();
        });
    },
    handleClose() {
      this.isDoubleReject = false;
      this.rejectMessage = "";
    },
  },
};
</script>
